import { getCurrencySymbol } from "@angular/common";


export function buildFormData(values: any): FormData {
  const formData = new FormData();

  Object.keys(values).forEach(key => {
    const value = values[key];

    // skip null or undefined
    if (value === null || value === undefined || value === '') {
      return;
    }

    // handle nested objects (flat key:value)
    if (typeof value === 'object' && !(value instanceof File)) {
      Object.keys(value).forEach(innerKey => {
        const innerValue = value[innerKey];
        if (innerValue !== null && innerValue !== undefined && innerValue !== '') {
          formData.append(`${key}.${innerKey}`, innerValue);
        }
      });
    } else {
      formData.append(key, value);
    }
  });

  return formData;
}

export class Utils {
  public static currencySymbol(iso4127Code: string, defaultSymbol: string = null): string {
    let symbol = getCurrencySymbol(iso4127Code, 'narrow');
    if (symbol == iso4127Code) {
      switch (iso4127Code?.toLowerCase()) {
        case 'zwl':
          symbol = '$';
          break;
      }
    }
    if (defaultSymbol) {
      symbol = defaultSymbol;
    }
    return symbol;
  }

  public static numberOnly(e: KeyboardEvent): void {
    if (
      // Only allow digits 0-9
      (e.keyCode < 48 || e.keyCode > 57) &&
      // Only allow decimal point (.)
      e.key !== '.' &&
      // Allow backspace (keyCode 8)
      e.keyCode !== 8 &&
      // Allow arrow keys (37-40)
      (e.keyCode < 37 || e.keyCode > 40) &&
      // Allow numpad keys (1-9)
      (e.keyCode < 96 || e.keyCode > 105)
    ) {
      e.preventDefault();
    }
  }
}

export function formatWithCommas(value: number | null | undefined): string {
  if (value == null) return '--';
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}



// export const NATIONALITIES: string[] = [
//     "Afghan",
//     "Albanian",
//     "Algerian",
//     "American",
//     "Andorran",
//     "Angolan",
//     "Antiguan and Barbudan",
//     "Argentine",
//     "Armenian",
//     "Australian",
//     "Austrian",
//     "Azerbaijani",
//     "Bahamian",
//     "Bahraini",
//     "Bangladeshi",
//     "Barbadian",
//     "Belarusian",
//     "Belgian",
//     "Belizean",
//     "Beninese",
//     "Bhutanese",
//     "Bolivian",
//     "Bosnian and Herzegovinian",
//     "Botswanan",
//     "Brazilian",
//     "Bruneian",
//     "Bulgarian",
//     "Burkinabé",
//     "Burmese",
//     "Burundian",
//     "Cabo Verdean",
//     "Cambodian",
//     "Cameroonian",
//     "Canadian",
//     "Central African",
//     "Chadian",
//     "Chilean",
//     "Chinese",
//     "Colombian",
//     "Comorian",
//     "Congolese (Congo-Brazzaville)",
//     "Congolese (Congo-Kinshasa)",
//     "Costa Rican",
//     "Croatian",
//     "Cuban",
//     "Cypriot",
//     "Czech",
//     "Danish",
//     "Djiboutian",
//     "Dominican (Dominica)",
//     "Dominican (Dominican Republic)",
//     "Dutch",
//     "East Timorese",
//     "Ecuadorean",
//     "Egyptian",
//     "Emirati",
//     "Equatorial Guinean",
//     "Eritrean",
//     "Estonian",
//     "Eswatini",
//     "Ethiopian",
//     "Fijian",
//     "Finnish",
//     "French",
//     "Gabonese",
//     "Gambian",
//     "Georgian",
//     "German",
//     "Ghanaian",
//     "Greek",
//     "Grenadian",
//     "Guatemalan",
//     "Guinean",
//     "Bissau-Guinean",
//     "Guyanese",
//     "Haitian",
//     "Honduran",
//     "Hungarian",
//     "Icelandic",
//     "Indian",
//     "Indonesian",
//     "Iranian",
//     "Iraqi",
//     "Irish",
//     "Israeli",
//     "Italian",
//     "Ivorian",
//     "Jamaican",
//     "Japanese",
//     "Jordanian",
//     "Kazakh",
//     "Kenyan",
//     "Kiribati",
//     "North Korean",
//     "South Korean",
//     "Kuwaiti",
//     "Kyrgyz",
//     "Lao",
//     "Latvian",
//     "Lebanese",
//     "Lesotho",
//     "Liberian",
//     "Libyan",
//     "Liechtensteiner",
//     "Lithuanian",
//     "Luxembourgish",
//     "Malagasy",
//     "Malawian",
//     "Malaysian",
//     "Maldivian",
//     "Malian",
//     "Maltese",
//     "Marshallese",
//     "Mauritanian",
//     "Mauritian",
//     "Mexican",
//     "Micronesian",
//     "Moldovan",
//     "Monégasque",
//     "Mongolian",
//     "Montenegrin",
//     "Moroccan",
//     "Mozambican",
//     "Namibian",
//     "Nauruan",
//     "Nepalese",
//     "New Zealander",
//     "Nicaraguan",
//     "Nigerien",
//     "Nigerian",
//     "North Macedonian",
//     "Norwegian",
//     "Omani",
//     "Pakistani",
//     "Palauan",
//     "Palestinian",
//     "Panamanian",
//     "Papua New Guinean",
//     "Paraguayan",
//     "Peruvian",
//     "Filipino",
//     "Polish",
//     "Portuguese",
//     "Qatari",
//     "Romanian",
//     "Russian",
//     "Rwandan",
//     "Kittitian and Nevisian",
//     "Saint Lucian",
//     "Saint Vincentian",
//     "Samoan",
//     "San Marinese",
//     "Sao Tomean",
//     "Saudi",
//     "Senegalese",
//     "Serbian",
//     "Seychellois",
//     "Sierra Leonean",
//     "Singaporean",
//     "Slovak",
//     "Slovene",
//     "Solomon Islander",
//     "Somali",
//     "South African",
//     "South Sudanese",
//     "Spanish",
//     "Sri Lankan",
//     "Sudanese",
//     "Surinamese",
//     "Swedish",
//     "Swiss",
//     "Syrian",
//     "Taiwanese",
//     "Tajik",
//     "Tanzanian",
//     "Thai",
//     "Togolese",
//     "Tongan",
//     "Trinidadian or Tobagonian",
//     "Tunisian",
//     "Turkish",
//     "Turkmen",
//     "Tuvaluan",
//     "Ugandan",
//     "Ukrainian",
//     "Uruguayan",
//     "Uzbek",
//     "Vanuatuan",
//     "Vatican",
//     "Venezuelan",
//     "Vietnamese",
//     "Yemeni",
//     "Zambian",
//     "Zimbabwean"
//   ];


export const NATIONALITIES: string[] = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo (Congo-Brazzaville)",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Democratic Republic of the Congo",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar (Burma)",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine State",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States of America",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe"
];
